<template>
  <div ref="form">
    <fieldset class="border flex items-center justify-between">
      <div class="text-sm flex items-center gap-1">
        Hub:
        <slot v-if="hub.switchable">
          <container-hub
            :container="{ id: tl.id, hub_id: tl.hub_id }"
            :hubs="hubs"
          />
        </slot>
        <slot v-else>{{ hub.name }}</slot>
      </div>
      <div class="flex items-center gap-1">
        <i class="el-icon-circle-plus text-sm green" />
        <slot v-for="(item, index) in newPopups">
          <el-divider v-if="index != 0" direction="vertical" />
          <popup
            componentPath="components/html"
            className="text-xs no-underline"
            width="800px"
            :pivot-y="0"
            :options="{ title: `New ${item.type}`, url: item.url }"
            @closed="item.callback"
            :key="index"
          >
            <span>{{ item.type }}</span>
          </popup>
        </slot>
      </div>
    </fieldset>
    <div class="e-form">
      <el-form
        label-position="top"
        ref="form"
        :model="tl"
        size="mini"
        class="flex flex-col gap-1"
      >
        <!-- Very Important; See operations.vue -> newOperation -->
        <div>
          <input
            type="hidden"
            name="order_type"
            id="order_type"
            value="TlContainer"
          />
          <div class="grid grid-cols-12 gap-1">
            <div class="col-span-4" v-if="isAdmin">
              <el-form-item
                required
                label="Customer"
                :error="errors.customer_id"
              >
                <el-select
                  filterable
                  clearable
                  v-model="tl.customer_id"
                  placeholder="choose customer"
                  class="full-width"
                  :disabled="tl.scheduled"
                >
                  <el-option
                    v-for="item in options.customers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </div>
            <div class="col-span-2" v-if="isAdmin">
              <el-form-item label="Contact" :error="errors.contact_id">
                <el-select
                  filterable
                  clearable
                  v-model="tl.contact_id"
                  placeholder="choose contact"
                  class="full-width"
                  :disabled="tl.scheduled"
                >
                  <el-option
                    v-for="item in options.contacts"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </div>
            <div class="col-span-4">
              <el-form-item label="Refer No.">
                <el-input
                  v-model="tl.reference_no"
                  placeholder="Auto if Empty"
                  clearable
                />
              </el-form-item>
            </div>
            <div class="col-span-2">
              <el-form-item
                required
                label="Billing Type"
                :error="errors.billing_type"
              >
                <el-select v-model="tl.billing_type" clearable>
                  <el-option
                    v-for="item in options.billingTypes"
                    :key="item.name"
                    :label="item.title"
                    :value="item.name"
                  />
                </el-select>
              </el-form-item>
            </div>
            <div class="col-span-2">
              <el-form-item :error="errors.container_no">
                <div slot="label" class="text-xs relative w-36">
                  Cont./Trailer
                  <div class="absolute -top-2 right-0.5">
                    <el-checkbox v-model="tl.own_trailer" @change="ownTrailer"
                      >Own</el-checkbox
                    >
                  </div>
                </div>
                <el-autocomplete
                  v-model="tl.container_no"
                  clearable
                  size="mini"
                  class="inline-input upcase"
                  :popper-append-to-body="false"
                  :fetch-suggestions="trailerList"
                  @select="trailerSelect"
                  @change="trailerChanged"
                />
              </el-form-item>
            </div>
            <div class="col-span-2">
              <el-form-item label="Size Type" :error="errors.ctype">
                <el-select v-model="tl.ctype" filterable clearable>
                  <el-option
                    v-for="ctype in options.ctypes"
                    :key="ctype"
                    :label="ctype"
                    :value="ctype"
                  />
                </el-select>
              </el-form-item>
            </div>
            <div
              class="col-span-2"
              v-if="
                fieldEnabled('triaxle') ||
                fieldEnabled('tank') ||
                fieldEnabled('haz_cargo')
              "
            >
              <el-form-item label=" ">
                <div class="flex items-center container-features">
                  <el-checkbox
                    v-if="fieldEnabled('triaxle')"
                    v-model="tl.triaxle"
                  >
                    Triaxle
                  </el-checkbox>
                  <container-tank
                    v-if="tlInited && fieldEnabled('tank')"
                    :tank="tl.tank"
                    :category_id="categories.tanker"
                    @syncTank="syncTank"
                  />
                  <container-hazardous
                    v-if="tlInited && fieldEnabled('haz_cargo')"
                    :haz_cargo="tl.haz_cargo"
                    :category_id="categories.hazardous"
                    @syncHazCargo="syncHazCargo"
                  />
                </div>
              </el-form-item>
            </div>
            <div class="col-span-2" v-if="fieldEnabled('seal_no')">
              <el-form-item label="Seal No." :error="errors.seal_no">
                <el-input v-model="tl.seal_no" class="upcase" clearable />
              </el-form-item>
            </div>
            <div class="col-span-2">
              <el-form-item label="Truck No." :error="errors.truck_no">
                <e-combobox
                  v-if="tlInited"
                  class="truck-combobox"
                  :options="truckList"
                  :input="{
                    value: tl.truck_no,
                    change: (value) => (tl.truck_no = value),
                  }"
                />
              </el-form-item>
            </div>
            <div class="col-span-2" v-if="fieldEnabled('rail_lfd')">
              <el-form-item label="Last Free Day" :error="errors.rail_lfd">
                <el-date-picker
                  v-model="tl.rail_lfd"
                  type="date"
                  :value-format="'yyyy-MM-dd'"
                  class="full-width"
                />
              </el-form-item>
            </div>
            <div class="col-span-6 flex items-center gap-1">
              <el-form-item label="Appt Date">
                <el-date-picker
                  v-model="tl.appt_date"
                  type="date"
                  :value-format="'yyyy-MM-dd'"
                  class="full-width"
                />
              </el-form-item>
              <el-form-item label="Start">
                <el-time-select
                  v-model="tl.appt_start"
                  :disabled="!tl.appt_date"
                  :picker-options="timePickerOptions"
                  class="full-width"
                />
              </el-form-item>

              <el-form-item label="End">
                <el-time-select
                  v-model="tl.appt_end"
                  :disabled="!tl.appt_start"
                  :picker-options="{
                    ...timePickerOptions,
                    minTime: tl.appt_start,
                  }"
                  class="full-width"
                />
              </el-form-item>
            </div>
            <div class="col-span-2" v-if="fieldEnabled('chassis_stencil')">
              <el-form-item
                label="Chassis Stencil"
                :error="errors.chassis_stencil"
              >
                <el-select v-model="tl.chassis_stencil" filterable clearable>
                  <el-option
                    v-for="item in options.chassisStencils"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </div>
            <div class="col-span-2" v-if="fieldEnabled('chassis_type')">
              <el-form-item label="Chassis Type" :error="errors.chassis_type">
                <el-select v-model="tl.chassis_type" filterable clearable>
                  <el-option
                    v-for="item in options.chassisTypes"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </div>
            <div class="col-span-2" v-if="fieldEnabled('chassis_no')">
              <el-form-item label="Chassis No." :error="errors.chassis_no">
                <e-combobox
                  v-if="tlInited"
                  :options="chassisList"
                  :input="{
                    value: tl.chassis_no,
                    change: (value) => (tl.chassis_no = value),
                    select: (item) => {
                      tl.chassis_stencil = item?.stencil;
                      tl.chassis_type = item?.stype;
                    },
                  }"
                />
              </el-form-item>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-1">
            <div class="col-span-6">
              <el-form-item label="Pickup Remarks">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="tl.pickup_remarks"
                  clearable
                >
                </el-input>
              </el-form-item>
            </div>
            <div class="col-span-6">
              <el-form-item label="Delivery Remarks">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="tl.delivery_remarks"
                  clearable
                >
                </el-input>
              </el-form-item>
            </div>
            <div class="col-span-12">
              <el-form-item label="Dispatch Comments">
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="tl.dispatch_comment"
                  clearable
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-1 empty:hidden">
          <div class="receivable-charges" v-if="$store.envs.access_receivable">
            <charge-form
              type="receivable"
              target="Tl"
              :items="tl.receivable_charges"
              :errors="receivableChargeErrors"
              key="receivable"
            />
          </div>
          <div class="payable-charges" v-if="$store.envs.access_payable">
            <charge-form
              type="payable"
              target="Tl"
              :items="tl.payable_charges"
              :errors="payableChargeErrors"
              key="payable"
            />
          </div>
        </div>
        <div class="border-2 border-sky-400 relative">
          <div
            class="flex items-center justify-between bg-white border-b h-12 px-3"
          >
            <div class="flex items-center">
              <div
                class="show-hide font-semibold text-base w-40"
                rel="carrier-items"
              >
                <i class="gray icon icons-min" />&nbsp;Carrier Items
              </div>
              <div class="flex items-center gap-2">
                <a class="no-underline" @click="newCarrierItem">
                  <i class="fas fa-plus-circle" />&nbsp;Item
                </a>
              </div>
            </div>
          </div>
          <div id="carrier-items">
            <table class="tbl text-2xs">
              <thead>
                <tr>
                  <th width="25">#</th>
                  <th width="90" class="required">
                    <el-tooltip
                      v-if="carrierItemErrors.stype"
                      :content="carrierItemErrors.stype"
                      placement="top"
                      class="red"
                    >
                      <span>Type</span>
                    </el-tooltip>
                    <slot v-else>Type</slot>
                  </th>
                  <th class="required">
                    <el-tooltip
                      v-if="carrierItemErrors.commodity"
                      :content="carrierItemErrors.commodity"
                      placement="top"
                      class="red"
                    >
                      <span>Commodity</span>
                    </el-tooltip>
                    <slot v-else>Commodity</slot>
                  </th>
                  <th width="60">
                    <el-tooltip
                      v-if="carrierItemErrors.pieces"
                      :content="carrierItemErrors.pieces"
                      placement="top"
                      class="red"
                    >
                      <span>PCS</span>
                    </el-tooltip>
                    <slot v-else>PCS</slot>
                  </th>
                  <th width="60">Stackable</th>
                  <th width="60">W(in)</th>
                  <th width="60">L(in)</th>
                  <th width="60">H(in)</th>
                  <th width="80">QTY</th>
                  <th width="90">
                    <el-tooltip
                      v-if="carrierItemErrors.weight"
                      :content="carrierItemErrors.weight"
                      placement="top"
                      class="red"
                    >
                      <span>W(lbs)</span>
                    </el-tooltip>
                    <slot v-else>W(lbs)</slot>
                  </th>
                  <th width="75">Frt. Class</th>
                  <th width="40">DEL.</th>
                </tr>
              </thead>
              <draggable
                v-model="tl.carrier_items"
                tag="tbody"
                handle=".seq-handle"
                @change="changeCarrierItemMark(tl.carrier_items)"
              >
                <tr v-for="(item, index) in tl.carrier_items" :key="index">
                  <td>
                    <a class="seq-handle">{{ item.mark }}</a>
                  </td>
                  <td>
                    <el-select
                      filterable
                      clearable
                      v-model="item.stype"
                      class="full-width"
                      size="mini"
                    >
                      <el-option
                        v-for="stype in options.stypes"
                        :key="stype.name"
                        :label="stype.title"
                        :value="stype.name"
                      />
                    </el-select>
                  </td>
                  <td>
                    <el-input v-model="item.commodity" size="mini" />
                  </td>
                  <td>
                    <el-input
                      v-model="item.pieces"
                      size="mini"
                      class="text-center"
                    />
                  </td>
                  <td>
                    <center>
                      <el-checkbox v-model="item.stackable" />
                    </center>
                  </td>
                  <td>
                    <el-input
                      v-model="item.width"
                      size="mini"
                      class="text-center"
                      type="number"
                      @change="calcNmfc(item)"
                    />
                  </td>
                  <td>
                    <el-input
                      v-model="item.length"
                      size="mini"
                      class="text-center"
                      type="number"
                      @change="calcNmfc(item)"
                    />
                  </td>
                  <td>
                    <el-input
                      v-model="item.height"
                      size="mini"
                      class="text-center"
                      type="number"
                      @change="calcNmfc(item)"
                    />
                  </td>
                  <td>
                    <el-input
                      v-model="item.qty"
                      size="mini"
                      class="text-center"
                      type="number"
                      @change="calcNmfc(item)"
                    />
                  </td>
                  <td>
                    <el-input
                      v-model="item.weight"
                      size="mini"
                      class="text-center"
                      type="number"
                      @change="calcNmfc(item)"
                    />
                  </td>
                  <td>
                    <el-input
                      v-model="item.freight_class"
                      size="mini"
                      class="text-center"
                    />
                  </td>

                  <td>
                    <el-checkbox
                      v-model="item._destroy"
                      :disabled="item.operated"
                    />
                  </td>
                </tr>
              </draggable>
            </table>
          </div>
        </div>
        <div class="error-messages" v-if="!isEmptyData(errors.operations)">
          <ul class="error-recap round-border">
            <li v-for="(errs, key) in errors.operations" :key="key">
              <span class="capitalize">{{ key.titleize() }}</span
              >: {{ errs }}
            </li>
          </ul>
        </div>
        <container-operations
          v-if="tl.transports"
          :admin="isAdmin"
          :iobi="false"
          :appt-time="apptTime"
          :ts="tl.transports"
          :os="tl.operations"
          :ctypes="options.ctypes"
          :chassises="options.chassisNumbers"
          :trailers="options.trailers"
          :types="otypes"
        />
        <div class="flex items-center">
          <el-form-item>
            <div class="flex items-center gap-2 my-1">
              <el-button class="submit-btn" type="primary" @click="saveOrder">
                Save TL
              </el-button>
              <div class="flex items-center" v-if="!id">
                <el-input-number
                  v-model="batch"
                  :step="1"
                  :min="1"
                  :max="99"
                  style="width: 100px"
                />
                <label class="border bg-white px-2">Batch QTY</label>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import api from "@/default/utils/api";
import eCombobox from "../../components/e-combobox.vue";
export default {
  components: { eCombobox },
  name: "TlForm",
  mixins: [api],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    hub: {
      type: Object,
      default: () => ({}),
    },
    hubs: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Object,
      default: () => ({}),
    },
    otypes: {
      type: Array,
      required: true,
    },
    apptTime: {
      type: Boolean,
      default: false,
    },
    cached: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      options: {
        customers: [],
        contacts: [],
        places: {},
        billingTypes: [],
        stypes: [],
        disabledFields: [],
        ctypes: [],
        chassisStencils: [],
        chassisTypes: [],
        chassisNumbers: [],
        trailers: [],
        trucks: [],
      },
      timePickerOptions: {
        start: "00:00",
        step: "00:15",
        end: "23:45",
      },
      tl: {
        billing_type: "col",
        carrier_items: [],
        receivable_charges: [],
        payable_charges: [],
      },
      tlInited: false,
      activeItem: null,
      companyId: null,
      batch: 1,
      errors: {},
    };
  },
  async created() {
    await this.loadOptions();
    await this.loadOrder();
    if (this.isAdmin) {
      await this.loadCustomers();
      await this.loadContacts();
    }
  },
  watch: {
    async customerId(nv, ov) {
      if (nv != ov) {
        if (window.ReceivableChargeForm) ReceivableChargeForm.setCustomerId(nv);
        await this.loadContacts();
      }
    },
  },
  computed: {
    turboFrame() {
      return this.$refs.form.closest("turbo-frame");
    },
    fieldEnabled() {
      return function (field) {
        return !this.options.disabledFields.includes(field);
      };
    },
    newPopups() {
      const groups = [];
      if (this.isAdmin) {
        groups.push({
          type: "Customer",
          url: `/customers/new`,
          callback: this.loadCustomers,
        });
        groups.push({
          type: "Terminal",
          url: `/terminals/new`,
          callback: () => {},
        });
      }
      groups.push({
        type: "Warehouse",
        url: `/warehouses/new`,
        callback: () => {},
      });
      groups.push({
        type: "Yard",
        url: `/yards/new`,
        callback: () => {},
      });
      groups.push({
        type: "Place",
        url: `/places/new`,
        callback: () => {},
      });

      return groups;
    },
    customerId() {
      return this.tl.customer_id;
    },
    truckList() {
      return this.options.trucks.map((o) => {
        return { id: o.id, value: o.number, label: o.name };
      });
    },
    chassisList() {
      return this.options.chassisNumbers;
    },
    apptDate() {
      return this.tl.appt_date;
    },
    isOperated() {
      return this.operations.filter((o) => o.operated_at).length > 0;
    },
    carrierItemErrors() {
      return this.errors.carrier_items || {};
    },
    receivableChargeErrors() {
      return this.errors.receivable_charges || {};
    },
    payableChargeErrors() {
      return this.errors.payable_charges || {};
    },
    operations() {
      return (this.tl.transports || []).map((o) => o.operations || []).flat();
    },
    compactRoutes() {
      return this.tl.transports.map((t) =>
        this._.pick(t, [
          "id",
          "appt_date",
          "appt_start",
          "sequence",
          "trucker_id",
          "truck_id",
          "payable_party_id",
          "trucker2_id",
          "payable_party2_id",
          "tenant",
          "carrier_id",
          "_destroy",
        ]),
      );
    },
    compactStops() {
      return this.operations.map((o) =>
        this._.pick(o, [
          "id",
          "company_id",
          "operation_type_id",
          "mode",
          "container_no",
          "ctype",
          "chassis_no",
          "pos",
          "sequence",
          "not_required_instruction",
          "instructions",
          "location",
          "_destroy",
        ]),
      );
    },
  },
  methods: {
    async loadOptions() {
      try {
        const response = await this.$http.get("/api/v1/options.json", {
          params: {
            targets: [
              "tls",
              "container_size_type",
              "chassis_stencils",
              "chassis_types",
              "chassis_nos",
              "trailers",
              "trucks",
            ],
          },
        });
        const data = response.data;
        const sizeTypes = data.container_size_type.tl;
        this.options.billingTypes = data.tls.billing_types;
        this.options.stypes = data.tls.stypes;
        this.options.disabledFields = data.tls.disabled_fields;
        this.options.ctypes = sizeTypes.map((o) => o[0]);
        this.options.chassisStencils = data.chassis_stencils;
        this.options.chassisTypes = data.chassis_types;
        this.options.chassisNumbers = data.chassis_nos;
        this.options.trailers = data.trailers;
        this.options.trucks = data.trucks;
      } catch (ex) {}
    },
    async loadCustomers() {
      try {
        const response = await this.$http.get("/api/v1/options.json", {
          params: {
            target: "customers",
            active: true,
            id: this.customerId,
          },
        });
        this.options.customers = response.data;
      } catch (ex) {}
    },
    async loadContacts() {
      try {
        this.options.contacts = [];
        if (this.customerId) {
          let response = await this.$http.get(
            `/api/v1/customers/${this.customerId}/contacts.json`,
            { params: { contact_id: this.tl.contact_id } },
          );
          const contacts = response.data;
          this.$set(this.options, "contacts", contacts);
          let contact =
            contacts.find((o) => o.id == this.tl.contact_id) ||
            contacts.find((o) => o.default);
          this.tl.contact_id = contact?.id;
        }
      } catch (ex) {}
    },
    trailerList(queryString, cb) {
      cb(
        this.options.trailers.map((o) => {
          return { id: o.id, value: o.number, ctype: o.ctype };
        }),
      );
    },
    trailerSelect(item) {
      this.tl.ctype = item.ctype;
      this.tl.trailer_id = item.id;
      this.tl.own_trailer = true;
    },
    trailerChanged(number) {
      let trailer = number
        ? this.options.trailers.find((o) => o.number == number)
        : null;
      if (trailer) {
        this.tl.trailer_id = trailer.id;
        this.tl.own_trailer = true;
      } else {
        this.tl.trailer_id = null;
        this.tl.own_trailer = false;
      }
    },
    ownTrailer() {
      this.trailerChanged(this.tl.own_trailer ? this.tl.container_no : null);
    },
    syncDueDate() {
      this.$set(this.tl, "due_date", this.tl.pickup_date);
    },
    syncTank(value) {
      this.tl.tank = value;
    },
    syncHazCargo(value) {
      this.tl.haz_cargo = value;
    },
    async loadOrder() {
      try {
        if (this.isEmptyData(this.cached)) {
          const url =
            this.id > 0 ? `/api/v1/tls/${this.id}` : `/api/v1/tls/new`;
          const response = await this.$http.get(url);
          this.tl = response.data;
        } else {
          this.tl = this.cached;
        }
        this.$nextTick(() => {
          this.tlInited = true;
        });
      } catch (ex) {}
    },
    saveOrder() {
      this.errors = [];
      const func = this.id > 0 ? this.$http.put : this.$http.post;
      const url = this.id > 0 ? `/api/v1/tls/${this.id}` : `/api/v1/tls`;
      let record = Object.assign({}, this.tl, {
        transports: this.compactRoutes,
        operations: this.compactStops,
      });
      record = this.nestedAttrs(record, "transports");
      record = this.nestedAttrs(record, "operations");
      record = this.nestedAttrs(record, "carrier_items");
      if (this.isAdmin) {
        record = this.nestedAttrs(record, "receivable_charges", "key");
        record = this.nestedAttrs(record, "payable_charges", "key");
      }
      func(url, { tl: record, batch: this.batch })
        .then((response) => {
          const data = response.data;
          if (Array.isArray(data)) {
            if (window.parent.TlList)
              data.forEach((item) => window.parent.TlList.syncItem(item));
            this.close();
          } else {
            if (window.parent.TlList) window.parent.TlList.syncItem(data);
            if (this.turboFrame) {
              let url = `/tl_containers/${data.id}?frame=${this.turboFrame.id}&layout=empty`;
              this.turboFrame.setAttribute("src", url);
            } else {
              window.location.href = `/tl_containers/${data.id}`;
            }
          }
          if (window.parent.LtlList) window.parent.LtlList.reload();
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
          window.scroll(0, 45);
        });
    },
    newCarrierItem() {
      const num = this._.max(this.tl.carrier_items.map((o) => o.mark));
      const mark = num ? parseInt(num) + 1 : 1;
      this.tl.carrier_items.push({ stype: null, mark });
    },
    changeCarrierItemMark(items) {
      items.forEach((item, index) => {
        item.mark = index + 1;
      });
    },
    calcNmfc(item) {
      const { width, length, height, qty, weight } = item;
      const empties = [width, length, height, qty, weight].filter((o) =>
        this.isEmptyData(o),
      );
      if (empties.length == 0) {
        this.$http
          .post("/api/v1/carrier_items/nmfc.json", { carrier_item: item })
          .then((response) => this.$set(item, "freight_class", response.data))
          .catch((err) => {});
      }
    },
    activeOperation(operation) {
      return operation._destroy != "1";
    },
    close() {
      if (this.turboFrame) {
        const popupForm = this.$refs.form.closest(".popup-form");
        if (popupForm) popupForm.setAttribute("close-confirmed", true);
        Dialog.close();
      } else {
        window.location.href = "/truckload";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
a.seq-handle {
  @apply block no-underline mx-auto bg-gray-500 text-white border rounded-2xl w-4 h-4 text-center text-2xs font-bold;
}
</style>
<style lang="scss">
.truck-combobox {
  .el-popper {
    @apply min-w-60 #{!important};
  }
}
.container-features {
  .el-checkbox {
    @apply px-0 #{!important};
    .el-checkbox__label {
      @apply pl-0.5 text-[11px] tracking-tighter #{!important};
    }
  }
}
</style>
